import { useSweepstakes } from '../../contexts/SweepstakesContext'
import { User, ChevronLeft } from 'lucide-react'
import Input from '../ui/Input'
import Button from '../ui/Button'

/**
 * Step2PersonalInfo
 * Second step: Collect full name
 */
const Step2PersonalInfo = () => {
  const {
    formData,
    updateFormData,
    goToNextStep,
    goToPreviousStep,
    errors
  } = useSweepstakes()

  const handleNext = () => {
    goToNextStep()
  }

  const handleBack = () => {
    goToPreviousStep()
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleNext()
    }
  }

  return (
    <div className="space-y-6">
      {/* Question */}
      <div className="text-center mb-6">
        <h3 className="text-xl font-semibold text-gray-900 mb-2">
          What's your name?
        </h3>
        <p className="text-sm text-gray-600">
          We'd love to know who we're talking to
        </p>
      </div>

      {/* Input */}
      <div>
        <Input
          label="Full Name"
          type="text"
          placeholder="First and Last Name"
          value={formData.fullName}
          onChange={(e) => updateFormData('fullName', e.target.value)}
          onKeyPress={handleKeyPress}
          error={errors.fullName}
          icon={<User className="w-4 h-4 text-gray-400" />}
          autoFocus
        />
      </div>

      {/* Navigation Buttons */}
      <div className="flex gap-3 pt-4">
        <Button
          onClick={handleBack}
          className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 py-3 rounded-lg font-semibold transition-colors"
        >
          <ChevronLeft className="w-4 h-4 inline mr-1" />
          Back
        </Button>
        <Button
          onClick={handleNext}
          className="flex-1 bg-purple-600 hover:bg-purple-700 text-white py-3 rounded-lg font-semibold transition-colors"
          disabled={!formData.fullName.trim()}
        >
          Continue
        </Button>
      </div>
    </div>
  )
}

export default Step2PersonalInfo
